import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import Tooltip from "antd/lib/tooltip";
import { PRODUCER_BUFFER_SIZE } from "Components/constants";
import { getProducer } from "Redux/selectors";
import Progress from "./Progress";
import Line from "./Line";
import Message from "./Message";
import Head from "./Head";
import Buffer from "./Buffer";
import styles from "./Producer.module.css";

type ProducerProps = {};

// eslint-disable-next-line no-empty-pattern
const Producer = ({}: ProducerProps) => {
    const producer = useSelector(getProducer);

    return (
        <Tooltip title="Producer" placement="topLeft">
            <div className={clsx(styles.root)}>
                <Line
                    direction="horizontal"
                    length={(PRODUCER_BUFFER_SIZE + 0.5) * 60}
                    className={styles.line}
                />
                <Head text="P" backgroundless />
                <Progress
                    duration={producer.interval - 0.25}
                    processedId={producer.recentMessage?.id}
                    delay={0.25}
                />
                <div className={styles.recentMessage}>
                    {producer.recentMessage && (
                        <Message
                            message={producer.recentMessage}
                            visible={false}
                        />
                    )}
                </div>
                <Buffer recentMessage={producer.recentMessage} delay={0} />
            </div>
        </Tooltip>
    );
};

export default Producer;
